// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__3f_aC","inherit--height":"List_inherit--height__2asKq","small--height":"List_small--height__3a5vL"};